import React from 'react';

import { makeStyles, Theme, Grid, createStyles, Box } from '@material-ui/core';
import { useStore } from '@roc/client-portal-shared/hooks';
import { PlaceHolderImage } from '@roc/feature-comp-tool';
import { AllPropertyPhotosGallery } from './allPropertyPhotosGallery';
import { ComparableProperty } from '../types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    allPhotosButton: {
      position: 'absolute',
      top: '70%',
      left: '30%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      width: '170px',
      '&:hover': {
        backgroundColor: '#ffffff',
      },
    }

  })
);

export interface ImagesGridProps {
  property: ComparableProperty;
  images: any[];
  imageStyles?: any;
  verticalImages?: boolean;
  showAllPhotosButton?: boolean;
  clickablePhotos?: boolean;
}

export const ImagesGrid: React.FC<ImagesGridProps> = ({
  property,
  images,
  imageStyles,
  verticalImages = false,
  clickablePhotos = false,
  showAllPhotosButton = true,
}) => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { compToolPhotosStore } = compToolStore;

  const classes = useStyles();

  const onError = (event) => {
    event.target.src = PlaceHolderImage;
  };

  const openIndividualPhotoDialog = (event, url) => {
    if (clickablePhotos && url !== PlaceHolderImage) {
      event.stopPropagation();
      compToolPhotosStore.setSelectedPhoto(url);
      compToolPhotosStore.setOpenIndividualPhoto(true);
    }
  }

  return (
    <Grid container spacing={1}>
      {images.map((url, index) => (
        <Grid item xs={6} sm={images.length <= 4 || verticalImages ? 6 : 4} md={images.length <= 4 || verticalImages ? 6 : 4} key={index}>
          {index === images.length - 1 ? (
            <div style={{
              position: 'relative',
              width: '100%',
              maxWidth: '400px',
            }}>
              <img
                src={url}
                alt="Property"
                loading="lazy"
                className={imageStyles}
                onError={onError}
                onClick={(event) => openIndividualPhotoDialog(event, url)}
              />
              {showAllPhotosButton &&
                <Box className={classes.allPhotosButton}>
                  <AllPropertyPhotosGallery buttonText="All Photos" property={property} buttonClassName={classes.allPhotosButton} />
                </Box>
              }
            </div>) : (
            <img
              src={url}
              loading="lazy"
              alt="Property"
              className={imageStyles}
              onError={onError}
              onClick={(event) => openIndividualPhotoDialog(event, url)}
            />
          )}

        </Grid>
      ))}
    </Grid>
  );
};
